import React, { useState, useEffect } from 'react';
import { Plus, Trash2, Zap, User } from 'lucide-react';
import api from '../../services/api';
import { toast } from 'react-toastify';

const CATEGORIES = ['', 'BPM / Flow Ürünleri', 'Logo Tiger / Go Ürünleri', 'Bordro Ürünleri', 'E-Devlet Ürünleri', 'Özel Yazılım ve Servis', 'Genel'];
const PRIORITIES = ['', 'Acil', 'Yüksek', 'Normal', 'Düşük'];

export default function AutoAssignPage() {
  const [rules, setRules] = useState([]);
  const [staff, setStaff] = useState([]);
  const [form, setForm] = useState({ category: '', priority: '', assignToUserId: '' });
  const [showForm, setShowForm] = useState(false);

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      const [rulesRes, staffRes] = await Promise.all([api.get('/auto-assign'), api.get('/users')]);
      setRules(rulesRes.data);
      setStaff(staffRes.data.filter(u => u.Role === 'admin' || u.Role === 'staff'));
    } catch (err) {}
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!form.assignToUserId) { toast.error('Personel seçimi zorunlu'); return; }
    try {
      await api.post('/auto-assign', {
        category: form.category || null,
        priority: form.priority || null,
        assignToUserId: parseInt(form.assignToUserId)
      });
      toast.success('Kural oluşturuldu');
      setShowForm(false);
      setForm({ category: '', priority: '', assignToUserId: '' });
      loadData();
    } catch (err) { toast.error('Hata'); }
  };

  const handleDelete = async (id) => {
    await api.delete(`/auto-assign/${id}`);
    toast.success('Kural silindi');
    loadData();
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">Otomatik Atama Kuralları</h1>
          <p className="text-sm text-slate-500 mt-1">Yeni ticket geldiğinde otomatik personel ataması</p>
        </div>
        <button onClick={() => setShowForm(true)}
          className="flex items-center gap-2 px-4 py-2.5 bg-blue-600 text-white rounded-xl text-sm font-semibold hover:bg-blue-700">
          <Plus size={16} /> Yeni Kural
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b">
            <tr>
              <th className="px-5 py-3 text-left text-xs font-semibold text-slate-500">Koşul</th>
              <th className="px-5 py-3 text-left text-xs font-semibold text-slate-500">Atanacak Personel</th>
              <th className="px-5 py-3 text-right text-xs font-semibold text-slate-500">İşlem</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rules.map(r => (
              <tr key={r.Id} className="hover:bg-slate-50">
                <td className="px-5 py-3">
                  <div className="flex flex-wrap gap-2">
                    {r.Category && <span className="text-xs bg-blue-50 text-blue-700 px-2 py-1 rounded-lg">Kategori: {r.Category}</span>}
                    {r.Priority && <span className="text-xs bg-amber-50 text-amber-700 px-2 py-1 rounded-lg">Öncelik: {r.Priority}</span>}
                    {!r.Category && !r.Priority && <span className="text-xs text-slate-400 italic">Tüm ticketlar</span>}
                  </div>
                </td>
                <td className="px-5 py-3">
                  <div className="flex items-center gap-2">
                    <div className="w-7 h-7 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white text-xs font-bold">
                      {r.AssignToName?.charAt(0)}
                    </div>
                    <span className="text-sm font-medium text-slate-800">{r.AssignToName}</span>
                  </div>
                </td>
                <td className="px-5 py-3 text-right">
                  <button onClick={() => handleDelete(r.Id)} className="p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-lg">
                    <Trash2 size={16} />
                  </button>
                </td>
              </tr>
            ))}
            {rules.length === 0 && <tr><td colSpan={3} className="text-center py-8 text-slate-400">Henüz kural tanımlanmamış</td></tr>}
          </tbody>
        </table>
      </div>

      {/* Info */}
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
        <div className="flex items-start gap-3">
          <Zap size={20} className="text-amber-600 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-amber-800">Kural Önceliklendirmesi</p>
            <p className="text-xs text-amber-700 mt-1">Kurallar spesifikten genele doğru değerlendirilir. Kategori + Öncelik belirtilen kural önce eşleştirilir. Hiçbir koşul belirtilmezse tüm ticketlar için geçerli olur.</p>
          </div>
        </div>
      </div>

      {/* Create Modal */}
      {showForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
            <div className="flex items-center justify-between px-6 py-4 border-b">
              <h3 className="text-lg font-semibold text-slate-800">Yeni Atama Kuralı</h3>
              <button onClick={() => setShowForm(false)} className="p-1 text-slate-400 hover:text-slate-600">✕</button>
            </div>
            <form onSubmit={handleCreate} className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Kategori (boş = tümü)</label>
                <select value={form.category} onChange={e => setForm({ ...form, category: e.target.value })}
                  className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500">
                  {CATEGORIES.map(c => <option key={c} value={c}>{c || 'Hepsi'}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Öncelik (boş = tümü)</label>
                <select value={form.priority} onChange={e => setForm({ ...form, priority: e.target.value })}
                  className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500">
                  {PRIORITIES.map(p => <option key={p} value={p}>{p || 'Hepsi'}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Atanacak Personel *</label>
                <select value={form.assignToUserId} onChange={e => setForm({ ...form, assignToUserId: e.target.value })} required
                  className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500">
                  <option value="">Seçiniz</option>
                  {staff.map(s => <option key={s.Id} value={s.Id}>{s.FullName}</option>)}
                </select>
              </div>
              <button type="submit" className="w-full py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700">Kural Oluştur</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
